import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";

class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "company_name",
        label: "Company Name",
        options: {
          filter: true
        }
      },
      {
        label: "Company Code",
        name: "company_code",
        options: {
          filter: true
        }
      },
      {
        label: "User Limit",
        name: "company_limit",
        options: {
          filter: true
        }
      },
      {
        label: "Phone Number",
        name: "company_telp",
        options: {
          filter: true
        }
      },
      {
        label: "Email",
        name: "company_email",
        options: {
          filter: true
        }
      },
      {
        label: "Address",
        name: "company_address",
        options: {
          filter: true
        }
      },
      // {
      //   name: "company_img",
      //   label: "Logo Path",
      //   options: {
      //     filter: false,
      //     display: false
      //   }
      // },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = tableMeta.rowData !== undefined ? tableMeta.rowData[0] : 0;
            if(localStorage.getItem('userlevel') != 3){
              return (
                <div>
                  <Button
                    color="danger"
                    round
                    onClick={() => this.props.handleDelete(id)}
                  >
                    Delete
                  </Button>
                  <Button
                    color="behance"
                    round
                    onClick={() => this.props.restate(tableMeta.rowData)}
                  >
                    Update
                  </Button>
                </div>
              );
            }else{
              return (<div/>)
            }
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Company Group"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default CompanyList;
